import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"

//User
import Users from "./users/reducer"

//Tracking
import Trackings from "./trackings/reducer"
import TrackingImages from "./trackings-images/reducer"
import TrackingSearch from "./trackings-search/reducer"

//Paginate
import Paginate from "./paginate/reducer"

//Container
import Containers from "./containers/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Users,
  Trackings,
  TrackingImages,
  TrackingSearch,
  Paginate,
  Containers,
})

export default rootReducer
